import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private _Step = 0; // @TODO 4 for test, 0 for product.
  public _isFlyout = false;
  constructor() { }

  get regStep() {
    return this._Step;
  }

  set regStep(value: number) {
    if (this._Step + 1 === value) {
      this._Step = value;
    }
  }

  resetStep() {
    this._Step = 0;
  }
}
